// app/javascript/components/Pagination.jsx
import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  const maxVisible = 5;

  const getPages = () => {
    const pages = [];

    let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let end = start + maxVisible - 1;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - maxVisible + 1);
    }

    // First page + dots
    if (start > 1) {
      pages.push(1);
      if (start > 2) pages.push('dots-start');
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    // Last page + dots
    if (end < totalPages) {
      if (end < totalPages - 1) pages.push('dots-end');
      pages.push(totalPages);
    }

    return pages;
  };

  return (
    <div style={{ padding: "16.5px", justifyContent: "center", display: "flex" }}>
      <nav aria-label="Page navigation">
        <ul className="pagination">

          {/* Previous */}
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <a
              className="page-link"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                if (currentPage !== 1) onPageChange(currentPage - 1);
              }}
            >
              &laquo;
            </a>
          </li>

          {/* Page Numbers */}
          {getPages().map((page, index) =>
            page === 'dots-start' || page === 'dots-end' ? (
              <li key={index} className="page-item disabled">
                <span className="page-link">...</span>
              </li>
            ) : (
              <li
                key={page}
                className={`page-item ${currentPage === page ? 'active' : ''}`}
              >
                <a
                  className="page-link"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    onPageChange(page);
                  }}
                >
                  {page}
                </a>
              </li>
            )
          )}

          {/* Next */}
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <a
              className="page-link"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                if (currentPage !== totalPages) onPageChange(currentPage + 1);
              }}
            >
              &raquo;
            </a>
          </li>

        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
